import _ from 'lodash';
import React, { useState } from 'react';
import { Button, FormLabel, FormControl } from 'react-bootstrap';
import PageContainer from '../PageContainer';
import Header from '../Header';
import ContentContainer from '../ContentContainer';
import ApiService from '../../services/ApiService';
import AuthService from '../../services/AuthService';
import toast from '../toastr';
import FileNotFound from '../FileNotFound';

const AdminDashboard = () => {
  const [output, setOutput] = useState('');
  const [args, setArgs] = useState('');

  const actions = {
    'db.reindex': {
      label: 'DB Reindex',
      func: () => ApiService.post('admin/db/reindex'),
    },

    'installzipcodes': {
      label: 'Install Zipcodes',
      func: () => ApiService.post('admin/installzipcodes'),
    },

    'list.remove': {
      label: 'List Remove',
      func: () => ApiService.post('admin/list/remove'),
    },

    'sys.services': {
      label: 'Test Services',
      func: () => ApiService.post('admin/sys/test-services'),
    },

    'archive.reindex-doc': {
      label: 'Reindex Archive Doc',
      func: () => {
        if (!args) {
          return Promise.reject(new Error('Set DocId/DocPath in Arguments'));
        }
        return ApiService.post('archive/reindex', { docId: args });
      },
    },
  };

  const [status, setStatus] = useState(
    ...Object.keys(actions).map(v => {
      return { [v]: false };
    })
  );

  if (!AuthService.isDsiSupport()) {
    return <FileNotFound />;
  }

  const handleAction = action => {
    setStatus({ ...status, [action]: true });
    actions[action]
      .func()
      .then(response => {
        setOutput(_.isString(response.data) ? response.data : JSON.stringify(response.data, null, 2));
        setStatus({ ...status, [action]: false });
        toast.success('Action Complete');
      })
      .catch(err => {
        setStatus({ ...status, [action]: false });
        toast.error(err.message);
        console.error(err);
      });
  };

  return (
    <PageContainer className="admin-dashboard">
      <Header title="Admin" showInfo={false} />
      <ContentContainer>
        <div>
          <pre style={{ overflowY: 'scroll', backgroundColor: 'black', color: 'white', height: '400px' }}>{output}</pre>
          {Object.keys(actions).map((action, i) => {
            return (
              <Button
                style={{ marginRight: '5px' }}
                key={i}
                onClick={() => handleAction(action)}
                disabled={status[action]}
              >
                {actions[action].label}
              </Button>
            );
          })}
          <div style={{ marginTop: '10px' }}>
            <FormLabel>Arguments</FormLabel>
            <FormControl type="text" value={args} onChange={e => setArgs(e.target.value)} />
          </div>
        </div>
      </ContentContainer>
    </PageContainer>
  );
};

export default AdminDashboard;
